import { gql } from '@apollo/client';

export const FETCH_PRODUCT_AUM_EXPOSURE_SOURCE = `
  query fetchProductAumExposure($input: FetchProductAumExposureInput!) {
    fetchProductAumExposure(input: $input) {
      totalCount
      totalMarketValueCents
      exposures {
        rank
        marketValueCents
        household {
          id
          name
        }
        user {
          id
          type
          firstName
          lastName
          entityName
        }
        account {
          id
          type
          custodianAccountNumber
          user {
            id
            type
            firstName
            lastName
            entityName
          }
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_AUM_EXPOSURE = gql(
  FETCH_PRODUCT_AUM_EXPOSURE_SOURCE,
);
